<template>
    <div class="m-share">
        <header>
            <div>
                <span class="g-fs32" s-cr="#323232" f-font-PFM>指数估值排行榜</span>
            </div>
            <div>
                <img src="../../assets/images/logo.png" alt="#">
            </div>
        </header>
        <section class="m-share-img" style="margin-bottom: 27px;">
            <fund-table v-if="initAllMeList && initAllMeList.length > 0" :initAllMeList="initAllMeList"></fund-table>
        </section>
        <footer>
            <div>
                <span class="g-fs24" s-cr="#999999" f-font-PFM>"学会估值，轻松投资"</span>
                <span class="g-fs20" s-cr="#999999" f-font-PFR>- 估值教父Aswath Damodaran</span>
                <span class="g-fs20" s-cr="#666666" f-font-PFR>扫描二维码下载同花顺爱基金APP</span>
            </div>
            <div>
                <img src="../../assets/images/qrcode.png" alt="#">
            </div>
        </footer>
        <!-- <div class="m-warter-wrapper"></div> -->
    </div>
</template>

<script>
    import FundTable from '@/components/Table1';
    import html2canvas from "html2canvas";
    export default {
        name: "share",
        props: {
            initAllMeList: {
                type: Array,
                default: () => []
            }
        },
        components: {
            FundTable
        },
        data() {
            return {
                headImage: '',
                bodyImage: {}
            }
        },
        methods: {
            gengrateImage(id, flag) {
                const _this = this;
                let _copyDom = document.getElementById(id);
                html2canvas(_copyDom, {
                    width: _copyDom.offsetWidth,
                    height: _copyDom.offsetHeight,
                    backgroundColor: "#FFFFFF",
                }).then(function(canvas) {
                    let _url = canvas.toDataURL();
                    if (flag === -1) {
                        _this.headImage = _url;
                    } else {
                        _this.$set(_this.bodyImage, `table${flag}`, _url);
                    }
                });
            },
        },
        mounted() {
        }
    }
</script>

<style lang="less" scoped>
.m-share {
    position: relative;
    width: 622px;
    padding: 40px;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 24px;
    overflow: auto;
    
    background-image: url('../../assets/images/watermark.png');
    background-repeat: repeat-y;
    background-size: 100% 174px;
    header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        div {
            &:first-child {
                span {
                    display: block;
                    line-height: 60px;
                    margin-bottom: 4px;
                    font-weight: bold;
                }
            }
        }
        img {
            width: 150px;
            height: 60px;
        }
    }
    footer {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        div {
            &:first-child {
                span {
                    display: block;
                    line-height: 38px;
                    &:last-child {
                        margin-top: 32px;
                    }
                }
            }
        }
        img {
            width: 136px;
            height: 136px;
        }
    }
    .m-warter-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-image: url('../../assets/images/watermark.png');
        background-repeat: repeat-y;
        background-size: 100% 174px;
        border-radius: 24px;
    }
    .m-share-img {
        img {
            width: 100%;
        }
    }
}
</style>